import { SCREEN_WIDTHS } from "components/utility/constants/screen_widths";

const onScrollStickyTile = () => {
	// Keep the tile below the sticky header as the page layout changes.
	const stickyTileSelector = ".one-third-sticky-container";
	const stickyHeaderSelector = ".sticky-header-el";
	const TOP_BUFFER = 16;

	const isDesktopWidth = () => window.matchMedia(`(min-width: ${SCREEN_WIDTHS.SM}px)`).matches;

	const updateStickyTop = () => {
		const stickyTileEl: HTMLDivElement | null = document.querySelector(stickyTileSelector);
		if (!stickyTileEl) return;
		if (!isDesktopWidth()) {
			stickyTileEl.style.position = "";
			stickyTileEl.style.top = "";
			return;
		}
		// Calculate the offset based on current sticky header height.
		const stickyTile = stickyTileEl.getBoundingClientRect();
		const stickyTileTop = stickyTile.top;
		const stickyHeader: HTMLDivElement | null = document.querySelector(stickyHeaderSelector);
		const nextStickyHeaderTop = stickyHeader
			? stickyHeader.getBoundingClientRect().height + TOP_BUFFER
			: 0;

		stickyTileEl.style.position = "sticky";
		if (nextStickyHeaderTop >= stickyTileTop) stickyTileEl.style.top = `${nextStickyHeaderTop}px`;
	};

	const waitForHeader = () => {
		// The header can mount after page load, so observe until it appears.
		const headerMountObserver = new MutationObserver(() => {
			if (document.querySelector(stickyHeaderSelector)) {
				if (isDesktopWidth()) updateStickyTop();
				headerMountObserver.disconnect();
			}
		});
		headerMountObserver.observe(document.body, { childList: true, subtree: true });
	};
	// Run once as soon as the header exists.
	waitForHeader();

	window.addEventListener("scroll", updateStickyTop);
	window.addEventListener("resize", updateStickyTop);
};

export { onScrollStickyTile };
